import { Swiper, Autoplay, EffectFade } from 'swiper';
import * as Globals from '../globals';

export default class Hero {
    static init() {
        new Hero();
    }

    constructor() {
        const swiperContainer = document.querySelector('.swiper.hero.amira');

        if (swiperContainer === null) return;

        this.swiperDelay = swiperContainer.dataset.swiperDelay;
               
        const config = {
            autoHeight: false,
            modules: [Autoplay, EffectFade],
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            loop: true,
            slidesPerView: 1,
            spaceBetween: 0,
            allowTouchMove: false,
            speed: 1500, 
            autoplay: {
                delay: this.swiperDelay * 1000, // in milliseconds
                disableOnInteraction: false,
            },
        };

        this.swiper = new Swiper(swiperContainer, config);
    }
}